export const getLangOptions = ({ repo }) =>
  Object.values(repo).map(({ key, label }) => ({
    key,
    label,
  }));
